import React, { useState } from 'react';
import {
  Collapse,
  NavbarToggler,
  Nav,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { NavbarLogo, FullNavbar, NavItems, LeftWrap, TopWrap, BottomWrap, ContactButton,WebNone, TopRightWrap, IconsWrap, IconItem } from './styles';
import {  FaBars, FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from "react-icons/fa";
import { useHistory } from "react-router-dom"
import { toast } from "react-toastify"

const Header = (props) => {
  toast.configure()

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);
  let history = useHistory()

  const handleLoginButton = () => {
    history.push('/login')
  }
  const logoutHandle = () => {
    localStorage.removeItem("token")
    notify("logoutsuccess")
    history.push("/")
  }

  const checkValue = localStorage.getItem("token");

  const notify = msg => {
    if (msg == "logoutsuccess") {
      toast.success("Logout Successfully")
    }
  }

  const handleLogoButton = () => {
    history.push('/user')
  }

  const handleAdminLogin = () => {
    history.push('/login')
  }

  return (
    <div>
      <FullNavbar light expand="lg">
        <NavbarLogo ><img src="/images/Axonics logo_color no tag_large.png" alt="" onClick={() => handleLogoButton()} style={{"cursor": "pointer"}} /></NavbarLogo>
        <LeftWrap>
          <TopWrap>
            <Nav className="mr-auto" navbar>
              <NavItems className="active">
                <NavLink href="/">Corporate</NavLink>
              </NavItems>
              <NavItems>
                <NavLink href="/">Healthcare Professionals</NavLink>
              </NavItems>
              <NavItems>
                <NavLink href="/" className="PatientLink">Patients</NavLink>
              </NavItems>
            </Nav>
            <TopRightWrap>
              <NavItems>
                <NavLink href="/">Health Policy Resources</NavLink>
              </NavItems>
              {/* <NavItems>
                <NavLink href="#" onClick={e => handleAdminLogin(e)}>Go to AdminLogin </NavLink>
              </NavItems> */}
               {localStorage.getItem("token") ? (
                <NavItems>
                  <NavLink href="#"  onClick={e => logoutHandle(e)} >Logout</NavLink>
                </NavItems>) : (
                  <NavItems>    
                    <NavLink href="#"  onClick={e => handleLoginButton(e)}>Login</NavLink>
                  </NavItems>
                )}
              <NavItems>
                <ContactButton>Contact Us</ContactButton>
              </NavItems>
              <IconsWrap>
                <IconItem>
                  <a href=""><FaFacebookF /></a>
                </IconItem>
                <IconItem>
                  <a href=""><FaInstagram /></a>
                </IconItem>
                <IconItem>
                  <a href=""><FaYoutube /></a>
                </IconItem>
                <IconItem>
                  <a href=""><FaLinkedinIn /></a>
                </IconItem>
              </IconsWrap>
              {/* {!isLoginCheck ? (
                <NavItems>
                  <NavLink href="#" className="mobile-button" onClick={e => handleLoginButton(e)}>Login</NavLink>
                </NavItems>) : (
                  <NavItems>
                    <NavLink href="#" className="mobile-button" onClick={e => logoutHandle(e)}>Logout</NavLink>
                  </NavItems>
                )} */}

            </TopRightWrap>
          </TopWrap>
          <NavbarLogo href="/"><img src="/images/Axonics logo_color no tag_large.png" alt="" /></NavbarLogo>
          <BottomWrap>
            <NavbarToggler onClick={toggle}>
              <FaBars />
            </NavbarToggler>
            <Collapse isOpen={isOpen} navbar>
              <Nav className="mr-auto" navbar>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    About Axonics
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      Who We Are
                    </DropdownItem>
                    <DropdownItem>
                      Corporate Governance
                    </DropdownItem>
                    <DropdownItem>
                      Leadership
                    </DropdownItem>
                    <DropdownItem>
                      Board of Directors
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    Investor Relations
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      Overview
                    </DropdownItem>
                    <DropdownItem>
                      News Releases
                    </DropdownItem>
                    <DropdownItem>
                      Events and Presentation
                    </DropdownItem>
                    <DropdownItem>
                      Stock Information
                    </DropdownItem>
                    <DropdownItem>
                      Analyst Coverage
                    </DropdownItem>
                    <DropdownItem>
                      SEC Filings
                    </DropdownItem>
                    <DropdownItem>
                      Resources
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    Careers
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      Our Culture
                    </DropdownItem>
                    <DropdownItem>
                      Employee Benefits
                    </DropdownItem>
                    <DropdownItem>
                      Career Opportunities
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown nav inNavbar style={{borderRight:"none"}}>
                  <DropdownToggle nav>
                    Contact Us
                  </DropdownToggle>
                </UncontrolledDropdown>
                <WebNone>
                {localStorage.getItem("token") ? (
                <NavItems>
                  <NavLink href="#"  onClick={e => logoutHandle(e)}>Logout</NavLink>
                </NavItems>) : (
                  <NavItems>    
                    <NavLink href="#"  onClick={e => handleLoginButton(e)}>Login</NavLink>
                  </NavItems>
                )}
                </WebNone>
                <IconsWrap className="mobile-show">
                <IconItem>
                  <a href=""><FaFacebookF /></a>
                </IconItem>
                <IconItem>
                  <a href=""><FaInstagram /></a>
                </IconItem>
                <IconItem>
                  <a href=""><FaYoutube /></a>
                </IconItem>
                <IconItem>
                  <a href=""><FaLinkedinIn /></a>
                </IconItem>
              </IconsWrap>
              </Nav>
            </Collapse>
          </BottomWrap>
        </LeftWrap>
      </FullNavbar>
    </div>
  );
}

export default Header;


// WEBPACK FOOTER //
// ./src/component/Header/index.js